import { defineComponent as _defineComponent } from 'vue'

import BadgeTypeUtil from "@/modules/utils/badgeTypeUtil";

interface Props {
	/**
	 * バッジ種別。
	 */
	badgeType: string | null;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    badgeType: { type: [String, null], required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * バッジ種別。
	 */
	badgeType: string | null;
}
/**
 * リプライ情報 > バッジ表示。
 */


/**
 * バッジが存在するかどうかを返却。
 * バッジがないのであれば表示しない。
 */
const isExistBadge = (): boolean => {
	if (props.badgeType === null) {
		return false;
	}
	return true;
};

/**
 * バッジ形式が公式ファンかどうか取得。
 */
const isOfficialFan = (): boolean => {
	return BadgeTypeUtil.isOfficialFan(props.badgeType);
};
/**
 * バッジ形式がスタッフかどうか取得。
 */
const isStaff = (): boolean => {
	return BadgeTypeUtil.isStaff(props.badgeType);
};

const __returned__ = { props, isExistBadge, isOfficialFan, isStaff }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})